import { RootState } from '@lon/shared/configs';

export const selectListType = (state: RootState) => state.scopes?.listType;

export const planData = (state: RootState) => state?.scopes?.planData;

export const userTeamIds = (state: RootState) => state?.planner?.teams?.teamIds;
